export const SceneKeys = {
  Boot: 'BootScene',
  Menu: 'MenuScene',
  Game: 'GameScene',
  GameOver: 'GameOverScene',
} as const;

export const TextureKeys = {
  BirdFrame1: 'bird-frame-1',
  BirdFrame2: 'bird-frame-2',
  PaperBackground: 'paper-background',
  ObstacleTop: 'obstacle-top',
  ObstacleBottom: 'obstacle-bottom',
  Ground: 'ground-strip',
  Cloud: 'doodle-cloud',
} as const;

export const AnimationKeys = {
  BirdFlap: 'bird-flap',
} as const;

export const AudioKeys = {
  Flap: 'flap',
  Score: 'score',
  Hit: 'hit',
  GameOver: 'game-over',
  MenuSelect: 'menu-select',
} as const;

export type AudioKey = (typeof AudioKeys)[keyof typeof AudioKeys];
